import SystemMessage from './messages/SystemMessage';
import TextMessage from './messages/TextMessage';
import GiftMessage from './messages/GiftMessage';
import SubscribeMessage from './messages/SubscribeMessage';
import JoinedMessage from './messages/JoinedMessage';
import SharedMessage from './messages/SharedMessage';
import FollowInvitationMessage from './messages/FollowInvitationMessage';
import LiveCompleted from '../../../../../basic/live-completed';
export default {
  name: 'Chatter',
  props: {
    playState: Boolean
  },
  data: function data() {
    return {
      messageList: [],
      isAtEndPosition: true
    };
  },
  components: {
    'text-message': TextMessage,
    'gift-message': GiftMessage,
    'system-message': SystemMessage,
    'subscribe-message': SubscribeMessage,
    'joined-message': JoinedMessage,
    'shared-message': SharedMessage,
    'follow-invitation-message': FollowInvitationMessage,
    'live-completed': LiveCompleted
  },
  mounted: function mounted() {
    this.$refs.container.addEventListener('scroll', this.updateScrollPosition);
  },
  methods: {
    clearMessage: function clearMessage() {
      this.messageList = [];
    },
    sendMessage: function sendMessage(message) {
      var extend1 = message.extend1;
      var content = message.content;
      switch (extend1) {
        case 'app:livestatmsgcontent':
          // 心跳
          break;

        // / 系统消息
        case 'DIY:welcome':
          this.messageList.push({
            type: 'system-message',
            content: content.content
          });
          break;

        // / 邀请关注主播
        case 'DIY:boardcasterfollowinvitation':
          this.messageList.push({
            type: 'follow-invitation-message',
            uid: content.uid,
            name: content.name,
            level: content.level,
            content: content.content
          });
          break;
        // / 文本消息
        case 'RC:TxtMsg':
          // 解析扩展字段
          var extra = JSON.parse((content === null || content === void 0 ? void 0 : content.extra) || '{}');
          var commonData = JSON.parse((extra === null || extra === void 0 ? void 0 : extra.common) || '{}');
          // 消息体
          var TxtMsgItem = {
            type: 'text-message',
            name: content.user.name,
            uid: content.user.id,
            level: JSON.parse(JSON.parse(content.extra).common).userLevel,
            content: content.content
          };
          // 神秘人模式下： 客户端 隐藏用户名
          var messageFlowHide = (commonData === null || commonData === void 0 ? void 0 : commonData.messageFlowHide) || null;
          if (messageFlowHide && messageFlowHide.hideName) {
            TxtMsgItem.name = messageFlowHide.hideName;
            TxtMsgItem.is_mysterious = 1;
          }
          // h5、studio 等非app 发送消息 ,需要服务端 告知 隐藏用户名
          if (content.user && content.user.is_mysterious) {
            TxtMsgItem.is_mysterious = 1;
          }
          this.messageList.push(TxtMsgItem);
          break;

        // / 送礼消息
        case 'app:giftmsgcontent':
          var giftMsgItem = {
            type: 'gift-message',
            name: content.name,
            uid: content.uid,
            level: JSON.parse(content.commonData).userLevel,
            action: this.$t('liveroom.giftsendaction'),
            giftId: content.gift_id,
            giftCount: content.giftcount,
            giftName: content.param2,
            giftImage: content.param1
          };
          // h5、studio 等非app 发送消息 ,需要服务端 告知 隐藏用户名
          if (content && content.is_mysterious) {
            giftMsgItem.is_mysterious = 1;
          }
          this.messageList.push(giftMsgItem);
          break;

        // / 进入直播间
        case 'app:joinchatroommsgcontent':
          /**
                 * -1为隐身用户，不在聊天im中提示
                 */
          if (content.inVisible == '-1') {
            return;
          }
          if (this.messageList.length && this.messageList[this.messageList.length - 1].type === 'joined-message') {
            var lastJoinMessage = this.messageList[this.messageList.length - 1];
            lastJoinMessage.name = content.name;
            lastJoinMessage.uid = content.uid;
            lastJoinMessage.level = JSON.parse(content.commonData).userLevel;
          } else {
            var joinMsgItem = {
              type: 'joined-message',
              name: content.name,
              uid: content.uid,
              level: JSON.parse(content.commonData).userLevel,
              content: this.$t('liveroom.joined')
            };
            // h5、studio 等非app 发送消息 ,需要服务端 告知 隐藏用户名
            if (content && content.is_mysterious) {
              joinMsgItem.is_mysterious = 1;
            }
            this.messageList.push(joinMsgItem);
          }
          break;
        case 'app:sharevideomsgcontent2':
          this.messageList.push({
            type: 'shared-message',
            name: content.name,
            uid: content.uid,
            level: JSON.parse(content.commonData).userLevel,
            content: this.$t('liveroom.shared')
          });
          break;

        // / 关注主播
        case 'app:followactressmsgcontent':
          this.messageList.push({
            type: 'subscribe-message',
            name: content.name,
            uid: content.uid,
            level: JSON.parse(content.commonData).userLevel,
            content: this.$t('liveroom.subscribeaction') + content.fname
          });
          break;
        default:
          break;
      }
    },
    updateScrollPosition: function updateScrollPosition() {
      this.isAtEndPosition = this.isAtEnd();
    },
    scrollToEnd: function scrollToEnd() {
      if (this.$refs.container) {
        this.isAtEndPosition = true;
        this.$refs.container.scrollTop = this.$refs.container.scrollHeight - this.$refs.container.clientHeight;
      }
    },
    isAtEnd: function isAtEnd() {
      if (!this.$refs.container) {
        return false;
      }
      return this.$refs.container.scrollTop + this.$refs.container.clientHeight >= this.$refs.container.scrollHeight;
    },
    scrollToEndHandler: function scrollToEndHandler() {
      if (this.isAtEndPosition) {
        this.scrollToEnd();
      }
    },
    openCardHandler: function openCardHandler(data, childRect) {
      this.$emit('opencard', data, 2, {
        x: childRect.x,
        y: childRect.y + 30
      });
    },
    subscribeHandler: function subscribeHandler(targetID, isFollowed) {
      this.$emit('subscribe', targetID, isFollowed);
    }
  }
};